import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            <span className="font-heading text-2xl">51黑料</span>
            <span className="hidden sm:inline text-sm text-foreground-600 font-sans">吃瓜网</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                location.pathname === "/"
                  ? "text-primary-500 bg-primary-50 font-medium"
                  : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.filter((c) => c.id !== "all").map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? "text-primary-500 bg-primary-50 font-medium"
                    : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                location.pathname === "/about"
                  ? "text-primary-500 bg-primary-50 font-medium"
                  : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-3 py-2.5 text-sm rounded-md text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              首页
            </Link>
            {categories.filter((c) => c.id !== "all").map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-3 py-2.5 text-sm rounded-md text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2.5 text-sm rounded-md text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}